import {IVodItemFragmentFragment} from '@src/Api/Graphql/gql/types.generated';
import useCastOnPage from '../../hooks/useCastOnPage';

export function useVodCasting(vodItem: IVodItemFragmentFragment | undefined) {
  useCastOnPage({
    sourceUrl: vodItem?.sourceUrl || undefined,
    vimeoId: `${vodItem?.liveEventId}` || undefined,
    title: vodItem?.title,
    currentTime: 0,
  });
}
